import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProject } from 'redux-store/api/projects';
// types
import {
  ICreateChecklistModalProps,
  ICreatePhaseItemModalProps,
  IEditChecklistModalProps,
  IPhaseItemModalSliceProps,
  IPhaseModalSliceProps,
  TSaveTemplateProps,
} from 'redux-store/types';
// utils
import {
  CREATE_CHECKLIST_MODAL_SLICE_DEFAULT_VALUES,
  CREATE_PHASE_ITEM_SLICE_DEFAULT_VALUES,
  PHASE_ITEM_MODAL_SLICE_DEFAULT_VALUES,
  EDIT_CHECKLIST_MODAL_DEFAULT_VALUES,
  PHASE_MODAL_SLICE_DEFAULT_VALUES,
  SAVE_TEMPLATE_MODAL_SLICE_DEFAULT_VALUES,
} from 'utils/constants/schedule-modals.constants';

export interface IScheduleModalsSlice {
  selectedProject: IProject;
  phaseModal: IPhaseModalSliceProps;
  saveTemplateModal: TSaveTemplateProps;
  phaseItemModal: IPhaseItemModalSliceProps;
  editChecklistModal: IEditChecklistModalProps;
  createPhaseItemModal: ICreatePhaseItemModalProps;
  createChecklistModal: ICreateChecklistModalProps;
}

const initialState: IScheduleModalsSlice = {
  selectedProject: null,
  phaseModal: PHASE_MODAL_SLICE_DEFAULT_VALUES,
  saveTemplateModal: SAVE_TEMPLATE_MODAL_SLICE_DEFAULT_VALUES,
  phaseItemModal: PHASE_ITEM_MODAL_SLICE_DEFAULT_VALUES,
  editChecklistModal: EDIT_CHECKLIST_MODAL_DEFAULT_VALUES,
  createPhaseItemModal: CREATE_PHASE_ITEM_SLICE_DEFAULT_VALUES,
  createChecklistModal: CREATE_CHECKLIST_MODAL_SLICE_DEFAULT_VALUES,
};

export const scheduleModalsSlice = createSlice({
  name: 'schedule-modals',
  initialState,
  reducers: {
    setPhaseModalProps: (state, action: PayloadAction<IPhaseModalSliceProps>) => {
      state.phaseModal = action.payload;
    },

    setSaveTemplaeProps: (state, action: PayloadAction<TSaveTemplateProps>) => {
      state.saveTemplateModal = action.payload;
    },

    setCurrentProjectProps: (state, action: PayloadAction<IProject>) => {
      state.selectedProject = action.payload;
    },

    setPhaseItemModalProps: (state, action: PayloadAction<IPhaseItemModalSliceProps>) => {
      state.phaseItemModal = action.payload;
    },

    setCreatePhaseItemModalProps: (state, action: PayloadAction<ICreatePhaseItemModalProps>) => {
      state.createPhaseItemModal = action.payload;
    },

    setCreateChecklistModalProps: (state, action: PayloadAction<ICreateChecklistModalProps>) => {
      state.createChecklistModal = action.payload;
    },

    setEditChecklistModalProps: (state, action: PayloadAction<IEditChecklistModalProps>) => {
      state.editChecklistModal = action.payload;
    },
  },
});

export const {
  setPhaseModalProps,
  setSaveTemplaeProps,
  setPhaseItemModalProps,
  setCurrentProjectProps,
  setEditChecklistModalProps,
  setCreateChecklistModalProps,
  setCreatePhaseItemModalProps,
} = scheduleModalsSlice.actions;

export default scheduleModalsSlice.reducer;
